import { CheckCircleIcon } from '@heroicons/react/20/solid';

type Props = {
  text: string;
};

export default function Snackbar(props: Props) {
  return (
    <div className="ml-[62px] mt-4 w-[900px] rounded-[6px] border-l-4 border-green-400 bg-green-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium leading-5 text-green-700">{props.text} </p>
        </div>
      </div>
    </div>
  );
}
